module.exports = __webpack_public_path__ + "static/media/kamal.f915b1b0.jpg";